import React from "react";
import classes from "./StudyGroup.module.css";
import { NavLink } from "react-router-dom";

const StudyGroup = ({ course, courseId, name, id, teacherFullName, isParticipant }) => {

    return <NavLink to={isParticipant ? `${id}` : `connect/${courseId}/${id}`} className={classes.StudyGtoup} >
        <div className={classes.BG} style={{ backgroundImage: `url(${course?.baseUrl}/${course?.additionalData && course?.additionalData.CardBackgroundImage})` }}></div>
        <div className={classes.CoureseName}>{course?.name}</div>
        {isParticipant ? <div className={classes.NameWrap}><div className={classes.Line}></div>
            <div className={`${classes.SGNAme} ${classes.Name}`}>{name}</div>
            <div className={`${classes.SGTNAme} ${classes.Name}`}>{teacherFullName}</div></div> :
            <div className={classes.SGDesc}>{course?.description}</div>

        }
    </NavLink>

}

export default StudyGroup;